import { useQuery } from "@tanstack/react-query";
import { useAction } from "convex/react";
import { Loader2 } from "lucide-react";
import { useQueryState } from "nuqs";
import { Link, Navigate } from "react-router";
import { api } from "../../../convex/_generated/api";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../components/ui/card";

export default function SetupOutlookCallbackPage() {
	const [code] = useQueryState("code");
	const [state] = useQueryState("state");
	const [oauthError] = useQueryState("error");
	const completeOAuth = useAction(
		api.integrations.providers.microsoft.oauth.completeMsOutlookOAuth,
	);

	const { error, isSuccess } = useQuery({
		queryKey: ["setup-outlook-callback", code, state],
		queryFn: () => {
			if (oauthError) throw new Error(oauthError);
			if (!code || !state) throw new Error("Missing OAuth parameters");
			return completeOAuth({ code, state });
		},
		enabled: !oauthError && !!code && !!state,
		retry: false,
		staleTime: Number.POSITIVE_INFINITY,
	});

	if (isSuccess) {
		return <Navigate to="/setup" replace />;
	}

	const hasError = !!error || !!oauthError;

	return (
		<section className="mx-auto flex min-h-[50vh] w-full max-w-3xl items-center px-4 py-12">
			<Card className="w-full shadow-sm">
				<CardHeader>
					<CardTitle>
						{hasError ? "Connection Failed" : "Connecting Outlook..."}
					</CardTitle>
					<CardDescription>
						{hasError
							? "There was an issue connecting your Outlook. Please go back and try again."
							: "Completing your Outlook connection. Please wait..."}
					</CardDescription>
				</CardHeader>
				<CardContent className="flex justify-center py-6">
					{hasError ? (
						<Link to="/setup" className="text-sm text-primary underline">
							Back to setup
						</Link>
					) : (
						<Loader2 className="h-8 w-8 animate-spin text-primary" />
					)}
				</CardContent>
			</Card>
		</section>
	);
}
